import { DocumentFieldUpdateItem } from '~/components/DocumentsViewPage/Document.data.types';
import { Field } from '~/features/document-handler/types/fields';
import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

import { Field as ApiFieldType } from './types';

interface Request {
  documentId: PilotId;
  fields: Array<DocumentFieldUpdateItem & { label?: string }>;
}

type Response = Array<{ value: ApiFieldType['value']; id: PilotId }>;

function mapApiFieldValue(value: ApiFieldType['value']): Field['value'] {
  if (!value) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((v) => ({
      displayValue: v.display_value,
      value: v.value,
    }));
  }
  return {
    displayValue: value.display_value,
    value: value.value,
  };
}

export const putDocumentUpdate = async (
  params: Request,
): Promise<Pick<Field, 'id' | 'value'>[]> => {
  const { documentId, fields } = params;

  const response: Response = await pilot.put(`/document/update/${documentId}`, [
    ...fields,
  ]);

  return response
    .filter((field) => field.id != null)
    .map((field) => ({
      id: field.id,
      value: mapApiFieldValue(field.value),
    })) as Pick<Field, 'id' | 'value'>[];
};
